import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DevolutivaService } from 'src/app/shared/api/licencas/devolutiva.service';

@Component({
    selector: 'app-devolutiva',
    templateUrl: './devolutiva.component.html',
    styleUrls: ['./devolutiva.component.scss']
})
export class DevolutivaComponent implements OnInit {

    idLicenca!: string;
    htmlDevolutiva!: string;


    mensagemErro: string = '';
    showLoader = true;

    constructor(
        private route: ActivatedRoute,
        private devolutivaService: DevolutivaService
    ) { }

    ngOnInit(): void {
        this.idLicenca = this.route.snapshot.paramMap.get('id')!;

        this.gerarDevolutiva();
    }

    private gerarDevolutiva() {
        this.devolutivaService.gerarDevolutiva(this.idLicenca).subscribe({
            next: () => {
                this.carregarDevolutiva();
            }
        });
    }

    private carregarDevolutiva(tentativas = 0): void {
        const MAX_TENTATIVAS = 200;

        this.devolutivaService.getDevolutiva(this.idLicenca).subscribe({
            next: (response) => {
                if (response.status === 'sucesso' && response.devolutiva) {
                    this.htmlDevolutiva = response.devolutiva.replaceAll('```html', '').replaceAll('```', '')
                        .replace(/<title[^>]*>[\s\S]*?<\/title>/gi, '');
                    this.showLoader = false;
                    return;
                }

                if (response.status === 'erro') {
                    this.mensagemErro = response.erro_msg || 'Ocorreu um erro desconhecido ao gerar a devolutiva.';
                    this.showLoader = false;
                    return;
                }

                if (tentativas < MAX_TENTATIVAS) {
                    setTimeout(() => {
                        this.carregarDevolutiva(tentativas + 1);
                    }, 5000); // espera 5 segundos antes de tentar novamente
                } else {
                    this.mensagemErro = 'Não foi possível gerar a devolutiva após várias tentativas. Por favor, tente novamente mais tarde.';
                    this.showLoader = false;
                }
            }
        });
    }


}
